import { render, staticRenderFns } from "./ModelForm.vue?vue&type=template&id=26f1a347&scoped=true&"
import script from "./ModelForm.vue?vue&type=script&lang=js&"
export * from "./ModelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f1a347",
  null
  
)

export default component.exports